import { decodeText } from "./decodeText";
import moment from "moment";
export const handleTextMessageShowContext = (message) => {
  const options = {
    text: decodeText(message),
  };
  return options;
};

// Parsing and handling image message display
export function handleImageMessageShowContext(message) {
  return {
    progress: message?.status === "unSend" && message.progress,
    url: message.image_elem_orig_url,
    width: message.image_elem_orig_pic_width,
    height: message.image_elem_orig_pic_height,
    message: message,
  };
}
export function handleFileMessageShowContext(item, message) {
  let size = "";
  if (item.file_elem_file_size >= 1024 * 1024) {
    size = `${(item.file_elem_file_size / (1024 * 1024)).toFixed(2)} Mb`;
  } else if (item.file_elem_file_size >= 1024) {
    size = `${(item.file_elem_file_size / 1024).toFixed(2)} Kb`;
  } else if (item.file_elem_file_size) {
    size = `${item.file_elem_file_size.toFixed(2)}B`;
  } else {
    size = "0B";
  }
  let send_at = message?.send_at || message.message_client_time;
  let date = moment(send_at * 1000 || new Date().getTime()).format("YYYY-MM");
  return {
    // progress: item?.status === "unSend" && item.progress,
    ...item,
    url: item.file_elem_url,
    message: item,
    name: item.file_elem_file_name,
    size: size,
    send_at,
    file_id: item.file_elem_file_id || message.file_uuid,
    im_msg_key: message.im_msg_key || message.message_msg_id || message.id,
    message_is_from_self: message.message_is_from_self,
    defaultHave: false,
    cancelled: false,
    date,
    messageData: message,
    custom_elem_data: !!item.custom_elem_data,
  };
}

export function handleLiveImageMessageShowContext(message) {
  return {
    url: message.imageUrl || message.url,
    width: message.width,
    height: message.height,
    size: message.size,
  };
}
export function handleLiveFileMessageShowContext(item, message) {
  //message
  let size = "";
  if (item.fileSize >= 1024 * 1024) {
    size = `${(item.fileSize / (1024 * 1024)).toFixed(2)} Mb`;
  } else if (item.fileSize >= 1024) {
    size = `${(item.fileSize / 1024).toFixed(2)} Kb`;
  } else if (item.fileSize) {
    size = `${item.fileSize.toFixed(2)}B`;
  } else {
    size = "0B";
  }
  let send_at = message?.time;
  let date = moment(send_at * 1000 || new Date().getTime()).format("YYYY-MM");
  return {
    // ...item,
    url: item.fileUrl, //文件地址
    // message: item,
    name: item.fileName, //文件名
    size: size, //文件大小
    send_at, //发送时间
    file_id: item.uuid, //唯一标识
    // im_msg_key: message.ID, // 消息ID
    // message_is_from_self: message.flow === "out", //是否是发送方
    // defaultHave: false,
    // cancelled: false,
    date,
    // messageData: message, // 消息数据
    // custom_elem_data: message.type === "custom", //是否是自定义消息
  };
}
export function handleGroupTipsMessageShowContext(message) {
  return message;
}
export function handleVideoMessageShowContext(message) {
  return message;
}
